import { z } from 'zod';

const ButtonThemePropertiesSchema = z
  .object({
    foregroundColor: z.string().optional(),
    backgroundColor: z.string().optional(),
    borderColor: z.string().optional(),
    borderSize: z.string().optional(),
    opacity: z.string().optional()
  })
  .optional();

const ButtonThemeStatesSchema = z
  .object({
    default: ButtonThemePropertiesSchema,
    hoverFocus: ButtonThemePropertiesSchema,
    active: ButtonThemePropertiesSchema
  })
  .optional();

export const ButtonTheme = z.object({
  borderRadius: z.string().optional(),
  primaryButton: ButtonThemeStatesSchema,
  secondaryButton: ButtonThemeStatesSchema
});
